import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from './arrow.module.scss';
import classnames from "classnames";

export class LeftArrowComponentProps extends BaseProps {
  className: String;
}

export const LeftArrow = (props: LeftArrowComponentProps) => {
  const className = classnames(props.className, styles.arrow);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" className={className}>
      <path d="M.405 9.009l8.485 8.485 1.215-1.215L2.83 9.006l7.289-7.288L8.908.506.405 9.009z"/>
    </svg>
  )
}
